export default __webpack_public_path__ + "static/media/Tags.dcef28f2.png";